export default () => {
    const heroForm = document.querySelector('.estate-hero-form');
    
    if (!heroForm) {
        return;
    }

    const purposeInput = heroForm.querySelector('#purpose');
    const inputLabels = heroForm.querySelectorAll('.input-label__label');
    purposeInput.addEventListener('change', (event) => toggleLabels(inputLabels, event.target.value));
}


const toggleLabels = (labels, purposeValue) => {
    labels.forEach(label => {
        const shouldDisplay = label.dataset.purpose === purposeValue;
        label.classList.toggle('d-none', !shouldDisplay);
    });
};
